/**
 * @member {string} current
 * @member {string} hash
 * @member {string} id
 * @member {string} success
 * @member {string|null} message
 * @member {string|null} next
 */
export class StepOneResponseDTO {
  constructor ({ current, hash, id, success, message = null, next = null }) {
    let properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }
    Object.defineProperty(this, 'current', Object.assign({ value: current }, properties));
    Object.defineProperty(this, 'hash', Object.assign({ value: hash }, properties));
    Object.defineProperty(this, 'id', Object.assign({ value: id }, properties));
    Object.defineProperty(this, 'success', Object.assign({ value: success }, properties));
    Object.defineProperty(this, 'message', Object.assign({ value: message }, properties));
    Object.defineProperty(this, 'next', Object.assign({ value: next }, properties));
    Object.freeze(this);
  }

  current;

  hash;

  id;

  success;

  message;

  next;
}
